import React from "react";
import Svg, { Path, Circle } from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function CollapseDetailsIcon(props) {
  const { isCollapsed } = props;

  return (
    <TouchableOpacity {...props}>
      {isCollapsed ? (
        <Svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Circle cx="6.33366" cy="6.33342" r="4.66667" fill="white" />
          <Path
            d="M6.24042 3.57689C6.13416 3.57676 6.03221 3.61891 5.95707 3.69405C5.88194 3.76919 5.83978 3.87113 5.83992 3.9774L5.84048 5.8402L3.97768 5.83963C3.75649 5.83963 3.57718 6.01895 3.57718 6.24014C3.57718 6.46133 3.75649 6.64064 3.97768 6.64064L5.84048 6.64008L5.83992 8.50288C5.83992 8.72407 6.01923 8.90339 6.24042 8.90339C6.46162 8.90339 6.64093 8.72407 6.64093 8.50288L6.64036 6.64008L8.50317 6.64064C8.64625 6.64064 8.77847 6.56431 8.85001 6.44039C8.92156 6.31647 8.92156 6.1638 8.85001 6.03989C8.77847 5.91597 8.64625 5.83963 8.50316 5.83963L6.64036 5.8402L6.64093 3.9774C6.64106 3.87114 6.59891 3.76919 6.52377 3.69405C6.44863 3.61891 6.34668 3.57676 6.24042 3.57689Z"
            fill="#239C9D"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.44043 6.23994C1.44043 3.58897 3.58946 1.43994 6.24043 1.43994C8.8903 1.44259 11.0378 3.59007 11.0404 6.23994C11.0404 8.89091 8.8914 11.0399 6.24043 11.0399C3.58946 11.0399 1.44043 8.89091 1.44043 6.23994ZM2.24023 6.24007C2.24023 8.44921 4.0311 10.2401 6.24023 10.2401C7.3011 10.2401 8.31852 9.81864 9.06866 9.0685C9.81881 8.31835 10.2402 7.30094 10.2402 6.24007C10.2402 4.03093 8.44937 2.24007 6.24023 2.24007C4.0311 2.24007 2.24023 4.03093 2.24023 6.24007Z"
            fill="#239C9D"
          />
        </Svg>
      ) : null}

      {!isCollapsed ? (
        <Svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Circle cx="6.33366" cy="6.33342" r="4.66667" fill="white" />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.44043 6.23994C1.44043 3.58897 3.58946 1.43994 6.24043 1.43994C8.8903 1.44259 11.0378 3.59007 11.0404 6.23994C11.0404 8.89091 8.8914 11.0399 6.24043 11.0399C3.58946 11.0399 1.44043 8.89091 1.44043 6.23994ZM2.24023 6.24007C2.24023 8.44921 4.0311 10.2401 6.24023 10.2401C7.3011 10.2401 8.31852 9.81864 9.06866 9.0685C9.81881 8.31835 10.2402 7.30094 10.2402 6.24007C10.2402 4.03093 8.44937 2.24007 6.24023 2.24007C4.0311 2.24007 2.24023 4.03093 2.24023 6.24007Z"
            fill="#239C9D"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.0872 6.67366H8.52456C8.75664 6.67366 8.94477 6.48553 8.94477 6.25346C8.94477 6.02138 8.75664 5.83325 8.52456 5.83325H4.0872C3.85512 5.83325 3.66699 6.02138 3.66699 6.25346C3.66699 6.48553 3.85512 6.67366 4.0872 6.67366Z"
            fill="#239C9D"
          />
        </Svg>
      ) : null}
    </TouchableOpacity>
  );
}
